var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfluence({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M44.412,12.968c0.453-0.737,0.961-1.593,1.393-2.274c0.387-0.652,0.179-1.494-0.467-1.892 l-9.057-5.564c-0.638-0.429-1.504-0.261-1.934,0.377c-0.018,0.027-0.035,0.054-0.051,0.082c-0.362,0.605-0.829,1.391-1.338,2.233 c-3.588,5.912-7.197,5.189-13.703,2.087l-8.952-4.243c-0.695-0.33-1.526-0.035-1.857,0.658C8.441,4.444,8.435,4.456,8.429,4.469 l-4.312,9.738c-0.305,0.695,0.005,1.506,0.697,1.822c1.895,0.89,5.664,2.664,9.057,4.299C26.104,26.239,36.477,25.843,44.412,12.968 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M3.588,36.032c-0.453,0.737-0.961,1.593-1.393,2.274c-0.387,0.652-0.179,1.494,0.467,1.892 l9.057,5.564c0.638,0.429,1.504,0.261,1.934-0.377c0.018-0.027,0.035-0.054,0.051-0.082c0.362-0.605,0.829-1.391,1.338-2.233 c3.588-5.912,7.197-5.189,13.703-2.087l8.952,4.243c0.695,0.33,1.526,0.035,1.857-0.658c0.006-0.012,0.012-0.025,0.017-0.037 l4.312-9.738c0.305-0.695-0.005-1.506-0.697-1.822c-1.895-0.89-5.664-2.664-9.057-4.299C21.896,22.761,11.523,23.157,3.588,36.032z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluence);
export default __webpack_public_path__ + "static/media/Confluence.e6c428a651aba41f4fda7699e696929c.svg";
export { ForwardRef as ReactComponent };